import Footer from 'src/components/Footer'
import Header from 'src/components/Header'

export function SignLayout({ children }) {
	return (
		<>
			<Header />
			<div className="body-layout">
				<div>{children}</div>
			</div>
			<Footer />
		</>
	)
}
